module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-reservation"
  }, [_c('div', {
    staticClass: "group-heading"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "reservation-badge"
  }, [_vm._v(_vm._s(_vm.form.status))])]), _vm._v(" "), _c('div', {
    staticClass: "group-form-grid"
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('label', [_vm._v("Golf club"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.golfClub),
      expression: "form.golfClub"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.golfClub)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "golfClub", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Reservation no."), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reservationNo),
      expression: "form.reservationNo"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.reservationNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "reservationNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("No. of holes"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.holes),
      expression: "form.holes"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "holes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("18")]), _c('option', [_vm._v("9")])])]), _vm._v(" "), _c('label', [_vm._v("1st course"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.firstCourse),
      expression: "form.firstCourse"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "firstCourse", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Tee box 1")]), _c('option', [_vm._v("Tee box 2")])])]), _vm._v(" "), _c('label', [_vm._v("Event"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.event),
      expression: "form.event"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.event)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "event", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "tournament-field"
  }, [_vm._v("Tournament"), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tournament),
      expression: "form.tournament"
    }],
    attrs: {
      "type": "radio",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.form.tournament, "yes")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.form, "tournament", "yes")
      }
    }
  }), _vm._v(" Yes "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tournament),
      expression: "form.tournament"
    }],
    attrs: {
      "type": "radio",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.form.tournament, "no")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.form, "tournament", "no")
      }
    }
  }), _vm._v(" No")])]), _vm._v(" "), _c('label', [_vm._v("Reservation by"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reservationBy),
      expression: "form.reservationBy"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.reservationBy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "reservationBy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Address"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Primary SOB"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.primarySob),
      expression: "form.primarySob"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.primarySob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "primarySob", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Secondary SOB"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.secondarySob),
      expression: "form.secondarySob"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.secondarySob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "secondarySob", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Note"), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('label', [_vm._v("Booking date"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bookingDate),
      expression: "form.bookingDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.form.bookingDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bookingDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("2nd course"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.secondCourse),
      expression: "form.secondCourse"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "secondCourse", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Tee box 10")]), _c('option', [_vm._v("Tee box 18")])])]), _vm._v(" "), _c('label', [_vm._v("Group customer ID"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.groupCustomerId),
      expression: "form.groupCustomerId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.groupCustomerId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "groupCustomerId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Payment term"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentTerm),
      expression: "form.paymentTerm"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.paymentTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentTerm", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "full-width"
  }, [_vm._v("Payment instruction"), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentInstruction),
      expression: "form.paymentInstruction"
    }],
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.form.paymentInstruction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentInstruction", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('label', [_vm._v("Reservation type"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reservationType),
      expression: "form.reservationType"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.reservationType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "reservationType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Status"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "status", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Tee time"), _c('div', {
    staticClass: "time-range"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.teeTimeFrom),
      expression: "form.teeTimeFrom"
    }],
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.form.teeTimeFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "teeTimeFrom", $event.target.value)
      }
    }
  }), _c('span', [_vm._v("to")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.teeTimeTo),
      expression: "form.teeTimeTo"
    }],
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.form.teeTimeTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "teeTimeTo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('label', [_vm._v("No. of flights"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.flights),
      expression: "form.flights"
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.form.flights)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "flights", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Mobile no."), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobileNo),
      expression: "form.mobileNo"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.mobileNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobileNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Phone no."), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phoneNo),
      expression: "form.phoneNo"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.phoneNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phoneNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "number-pair"
  }, [_c('label', [_vm._v("Number of player"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.playerCount),
      expression: "form.playerCount"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.form.playerCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "playerCount", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Number of member"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberCount),
      expression: "form.memberCount"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.form.memberCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "memberCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('label', [_vm._v("Group folio no."), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.groupFolioNo),
      expression: "form.groupFolioNo"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.groupFolioNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "groupFolioNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "requests-field"
  }, [_vm._v("Guest request (per flight)"), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.caddy),
      expression: "form.caddy"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.caddy) ? _vm._i(_vm.form.caddy, null) > -1 : (_vm.form.caddy)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.caddy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "caddy", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "caddy", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "caddy", $$c)
        }
      }
    }
  }), _vm._v(" Caddy  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cart),
      expression: "form.cart"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.cart) ? _vm._i(_vm.form.cart, null) > -1 : (_vm.form.cart)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.cart,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "cart", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "cart", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "cart", $$c)
        }
      }
    }
  }), _vm._v(" Cart")])])])]), _vm._v(" "), _c('div', {
    staticClass: "payment-panel"
  }, [_c('label', {
    staticClass: "payment-toggle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentByGroup),
      expression: "form.paymentByGroup"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.paymentByGroup) ? _vm._i(_vm.form.paymentByGroup, null) > -1 : (_vm.form.paymentByGroup)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.paymentByGroup,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "paymentByGroup", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "paymentByGroup", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "paymentByGroup", $$c)
        }
      }
    }
  }), _vm._v(" Payment by group")]), _vm._v(" "), (_vm.form.paymentByGroup) ? _c('div', {
    staticClass: "payment-grid"
  }, [_c('label', [_vm._v("Group rate code"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.groupRateCode),
      expression: "form.groupRateCode"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.groupRateCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "groupRateCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Rate amount"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.rateAmount),
      expression: "form.rateAmount"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.form.rateAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "rateAmount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Deposit"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.deposit),
      expression: "form.deposit"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.form.deposit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "deposit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Payment date"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Action"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.action),
      expression: "form.action"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "action", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Name List")]), _c('option', [_vm._v("Confirm")])])]), _vm._v(" "), _c('label', [_vm._v("Action date"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.actionDate),
      expression: "form.actionDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.form.actionDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "actionDate", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "group-actions"
  }, [_c('button', {
    staticClass: "btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('back')
      }
    }
  }, [_vm._v("Back to calendar")]), _vm._v(" "), _c('button', {
    staticClass: "btn-secondary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.form.status = 'Reserved'
      }
    }
  }, [_vm._v("Save reservation")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "eyebrow"
  }, [_vm._v("GOLF RESERVATION")]), _vm._v(" "), _c('h3', [_vm._v("Group Reservation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8243396"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Golf/GroupReservation.vue
// module id = 823
// module chunks = 1